import { __rest } from "tslib";
import * as React from 'react';
import { DropdownGroup } from '../Dropdown';
export var ApplicationLauncherGroup = function ApplicationLauncherGroup(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(DropdownGroup, Object.assign({}, props), children);
};